import customValidators from '@/utils/validators'
import * as validators from 'vuelidate/lib/validators'
import { DEFAULT_ERROR_MESSAGES } from '@/constants'

/**
 * @function configToValidation
 * @desc Converts `field.conifg.validations` Object values into actual validation functions.
 * It supports three cases:
 * 1. field.config.validations[vuelidateValidator]: validatorValue, e.g `minLength: 5`.
 *    This will assign field.config.validations.minLength with Vuelidate's validator.
 * 2. field.config.validations[customValidator]: validatorValue, e.g `notAllowedChars: X`.
 *    This will assign field.config.validations.notAllowedChars with our custom validator.
 *    These can be found in @/utils/validators.
 * 3. field.config.validations[customFunction]: validatorValue.
 *    This case allows to pass custom validator function directly on field.
 *    For example when we want field to be unique based on store values.
 *    We cannot have that in custom validators, because we don't know which deps are needed.
 * @param {Object} [field] - Field consumed by SchemaForm or DynamicForm.
 * @param {Object} [field.config.validations] - Validations names and values.
 * Usually set in db, but also mapped in code for some cases (e.g `unique`).
 */
export function configToValidation (field) {
  return Object
    .entries(field.config?.validations || {})
    .reduce((validations, [ validatorName, validatorValue ]) => {
      if (typeof validatorValue === 'function') {
        return {
          ...validations,
          [validatorName]: validatorValue,
        }
      }
      const validator = customValidators[validatorName] || validators[validatorName]
      return {
        ...validations,
        [validatorName]: validator(validatorValue),
      }
    }, {})
}

export function configToErrorMessages (field) {
  return Object
    .entries(field.config?.validations || {})
    .reduce((validations, [ validatorName, validatorValue ]) => {
      const errors = DEFAULT_ERROR_MESSAGES[validatorName] || DEFAULT_ERROR_MESSAGES._
      return {
        ...validations,
        [validatorName]: errors(validatorValue),
      }
    }, {})
}
